import React, { useEffect } from 'react';

import { bool } from 'prop-types';

import useRedirect from 'hooks/useRedirect';

import { UserPropTypes } from 'propTypes/UserPropTypes';

/**
 * Contains all redirect logic strictly for student users
 */
const RedirectHelper = ({ user, isDashboardRedirect, isMeRedirect }) => {
  const { currentStudentGrade } = user;
  const { redirect } = useRedirect();

  useEffect(() => {
    if (isMeRedirect) {
      redirect({
        to: '/profile/edit',
        component: 'routes/StudentRoutes/StudentRedirect',
        reason: 'redirecting to user profile page',
      });
    }
  }, [currentStudentGrade, isDashboardRedirect, isMeRedirect]);

  return <></>;
};

RedirectHelper.propTypes = {
  user: UserPropTypes,
  isDashboardRedirect: bool,
  isMeRedirect: bool,
};

RedirectHelper.defaultProps = {
  user: {},
  isDashboardRedirect: false,
  isMeRedirect: false,
};

export default RedirectHelper;
